const { assign } = require('lodash');

class ShopperService {
    constructor(Restangular, bootstrap, shopperAnalytics) {
        this.shopper = {};
        this.IsGuest = false;
        this.api = Restangular.one('shopper');
        this.myAccountApi = Restangular.one('myaccount');
        this.shopperAnalytics = shopperAnalytics;
        this.bootstrap = bootstrap;
        this.assignShopperDetails(bootstrap.getBootstrappedData(bootstrap.bootstrapped.Shopper));
        this.assignShopperPreferences(bootstrap.getBootstrappedData(bootstrap.bootstrapped.ShopperBasicPreferences));
        this.assignShopperLocation(bootstrap.getBootstrappedData(bootstrap.bootstrapped.ShopperDetails));
        this.assignShopperAdditionalDetails(bootstrap.getBootstrappedData(bootstrap.bootstrapped.ShopperDetails));
    }

    refreshShopperDetails() {
        this.assignShopperDetails(this.bootstrap.getBootstrappedData(this.bootstrap.bootstrapped.Shopper));

        return this.shopper;
    }

    getCurrentShopperDetails() {
        return this.api.one('detail').get().then(details => this.assignShopperAdditionalDetails(details));
    }

    getCurrentShopper() {
        return this.api.get().then(shopper => this.assignShopperDetails(shopper));
    }

    getBasicShopperPreferences() {
        return this.myAccountApi.one('BasicShopperPreferences').get().then(shopperPref => this.assignShopperPreferences(shopperPref));
    }

    getCurrentShopperPreferences() {
        return this.myAccountApi.one('ShopperPreferences').get();
    }

    updateShopperPersonalDetails(shopper) {
        return this.myAccountApi.one('PersonalDetails').doPOST(shopper).then(details => this.assignShopperAdditionalDetails(details));
    }

    updateShopperBusinessDetails(shopper) {
        return this.myAccountApi.one('BusinessDetails').doPOST(shopper).then(details => this.assignShopperAdditionalDetails(details));
    }

    getDeliveryPassesSummary() {
        return this.myAccountApi.one('DeliveryPasses').get();
    }

    shouldDisplayDeliveryPassNavLink() {
        return this.myAccountApi.one('DeliverySaverNavLinkEnabled').get();
    }

    setPreferenceEnableAccessibility(newValue) {
        return this.myAccountApi.one('ShopperPreferences/EnableAccessibleMenu').doPOST({ Value: newValue });
    }

    getAuthenticationMethod() {
        return this.api.one('AuthenticationMethod').get();
    }

    assignShopperDetails(details) {
        this.IsGuest = !details || details.IsGuest;
        assign(this.shopper, details);

        return this.shopper;
    }

    assignShopperPreferences(preferences) {
        this.preferences = {
            EnableAccessibleOptions: preferences ? preferences.EnableAccessibleMenu : false,
        };

        assign(this.preferences, preferences);

        return this.preferences;
    }

    assignShopperLocation(details) {
        this.location = {};

        if (details) {
            assign(this.location, details.Location);
        }

        return this.location;
    }

    assignRewardsPlusPurchaseInfo(rewardsPlusPurchaseInfo) {
        this.rewardsPlus = {};

        if (rewardsPlusPurchaseInfo) {
            assign(this.rewardsPlus, rewardsPlusPurchaseInfo);
        }

        return this.rewardsPlus;
    }

    assignShopperAdditionalDetails(details) {
        assign(this.shopper, details);
        this.shopperAnalytics.push(this.shopper);

        return this.shopper;
    }

    setMobilePhone(mobile, updateApi = true) {
        this.shopper.MobilePhone = mobile;
        if (updateApi) {
            return this.updateShopperPersonalDetails(this.shopper);
        }
        return this.shopper;
    }

    clearShopper() {
        this.shopper = {};
        this.IsGuest = true;
    }

    isBusinessShopper() {
        const shopper = this.shopper;
        return !!(shopper.IsBusinessAccount || shopper.ABN);
    }
}

module.exports = ShopperService;



// WEBPACK FOOTER //
// ./src/auth/shopper/shopper.service.js